
import _ from 'lodash'
import Vue from 'vue'
import utils from '@/core/utils'
import Bus from '@/core/message-bus'

// CONSTANS (should they be put somwhere else?) -------------------------------------------------------------------

export const DEFAULT_CATEGORY_NODE = 'default-category-node'
export const FILTER_TYPES = {
  category: 'category',
  facet: 'facet',
  vehicle: 'vehicle'
}

// STATE ----------------------------------------------------------------------------------------------

export const state = Vue.observable({
  vehicles: null,
  categories: null,
  facets: null,
  selectedVehicle: '',
  selectedCategory: '',
  selectableFacets: {},
  filtersInitialized: false,
  initialFacetOrder: {},
  fetchingFilters: false,
  accordionsThreshold: 3,
  hasAppliedFilterQueryParams: false
})

// COMPUTEDS (ish) ----------------------------------------------------------------------------------------------

export const sortedFacets = () => {
  _.forEach(state.facets, facet => {
    facet.order = state.initialFacetOrder[facet.id]
  })
  return _.orderBy(state.facets, 'order', 'asc')
}
export const selectedFacets = () => {
  const selected = _.chain(state.selectableFacets).pickBy(value => !_.isEmpty(value.distinctValues)).mapValues(val => val.distinctValues).value()
  const hasSelections = !_.isEmpty(selected)
  return hasSelections ? selected : {}
}
export const selectedRangeFacets = () => {
  const selected = _.chain(state.selectableFacets).pickBy(value => value.isRange).mapValues(val => {
    if(_.isEmpty(val.userSelection)) return {}
    else {
      return { min: val.userSelection[0], max: val.userSelection[1] }
    }
  }).pickBy(v => !_.isEmpty(v)).value()
  const hasSelections = !_.isEmpty(selected)
  return hasSelections ? selected : {}
}
export const selectedVehicle = () => state.selectedVehicle ? state.selectedVehicle : ''
export const selectedCategory = () => state.selectedCategory === DEFAULT_CATEGORY_NODE ? '' : state.selectedCategory
export const hasCategories = () => state.categories && !_.isEmpty(state.categories)
export const hasVehicles = () => state.vehicles && !_.isEmpty(state.vehicles)
export const hasFacets = () => state.facets && !_.isEmpty(state.facets)
export const hasSelectableFacets = () => !_.isEmpty(state.selectableFacets)
export const lastFacetUsed = () => JSON.parse(sessionStorage.getItem('lastFacetUsed'))
export const hasSelectedFilters = () => {
  return selectedVehicle() || selectedCategory() || (selectedFacets() && !_.isEmpty(selectedFacets())) || (selectedRangeFacets() && !_.isEmpty(selectedRangeFacets()))
}
export const orgFacets = () => _.map(state.selectableFacets, (value, key) => key)
export const orgRangeFacets = () => {
  const filtered = _.chain(state.selectableFacets).pickBy(value => value.isRange).map((value, key) => key).value()
  return filtered
}
export function selectedFilters() {
  return { selectedFacets: selectedFacets(), selectedRangeFacets: selectedRangeFacets(), selectedVehicle: selectedVehicle(), selectedCategory: selectedCategory() }
}

export function allFilterParameters() {
  return {
    facets: selectedFacets(),
    rangeFacets: selectedRangeFacets(),
    vehicleFilter: selectedVehicle(),
    categoryFilter: selectedCategory(),
    lastFacetUsed: lastFacetUsed(),
    orgFacets: orgFacets(),
    orgRangeFacets: orgRangeFacets()
  }
}

// FUNCTIONS ----------------------------------------------------------------------------------------------

export function storeFilters(data) {
  state.accordionsThreshold = data.accordionsThreshold
  const lastFacetUsed = data.lastFacetUsed
  updateFacets(lastFacetUsed, data)
  updateCategories(lastFacetUsed, data)
  state.vehicles = data.vehicles
}

function updateFacets(lastFacetUsed, data) {
  const currentFacetsFlattend = _.chain(state.facets).flatMap(p => p.specificationFilterCategories).flatMap(b => b.specificationFilterFields).value()
  const newFacetsFlattend = _.chain(data.facets).flatMap(p => p.specificationFilterCategories).flatMap(b => b.specificationFilterFields).value()

  if(lastFacetUsed && lastFacetUsed.type === FILTER_TYPES.facet) {
    const lastFacetUsedValue = _.find(currentFacetsFlattend, facet => { return facet.id === lastFacetUsed.id })
    let facetToUpdate = _.find(newFacetsFlattend, facet => { return facet.id === lastFacetUsed.id })
    _.merge(facetToUpdate, lastFacetUsedValue)
  }

  const newRangeFacets = _.filter(newFacetsFlattend, facet => !!facet.range)
  _.forEach(newRangeFacets, facet => {
    state.selectableFacets[facet.id].currentMinMax[0] = facet.range.min
    state.selectableFacets[facet.id].currentMinMax[1] = facet.range.max
  })

  state.facets = data.facets
}

function updateCategories(lastFacetUsed, data) {
  if(lastFacetUsed && (lastFacetUsed.type === FILTER_TYPES.category) && (lastFacetUsed.id !== DEFAULT_CATEGORY_NODE)) {
    // Do not update categories
  } else {
    state.categories = data.categories
  }
}

export function storeInitialFacetOptions(data) {
  if(data.facets) {
    _.forEach(data.facets, (facet, index) => {
      Vue.set(state.initialFacetOrder, facet.id, index)
      _.forEach(facet.specificationFilterCategories, category => {
        _.forEach(category.specificationFilterFields, field => {
          if(field.range) {
            const min = Math.floor(field.range.min)
            const max = Math.ceil(field.range.max)
            Vue.set(state.selectableFacets, field.id, { isRange: true, distinctValues: [], currentMinMax: [min, max], originalMinMax: [min, max], userSelection: [] })
          } else {
            Vue.set(state.selectableFacets, field.id, { isRange: false, distinctValues: [] })
          }
        })
      })
    })
  }
}

export function setFilterQueryParams() {
  utils.setQueryStringParameter('facets', JSON.stringify(selectedFacets()))
  utils.setQueryStringParameter('rangeFacets', JSON.stringify(selectedRangeFacets()))
  utils.setQueryStringParameter('vehicleFilter', selectedVehicle())
  utils.setQueryStringParameter('categoryFilter', selectedCategory())
}

export function getUrlFilterQueryParams() {
  const facets = utils.getQueryStringParam('facets') && JSON.parse(utils.getQueryStringParam('facets'))
  const rangeFacets = utils.getQueryStringParam('rangeFacets') && JSON.parse(utils.getQueryStringParam('rangeFacets'))
  const categoryFilter = utils.getQueryStringParam('categoryFilter')
  const vehicleFilter = utils.getQueryStringParam('vehicleFilter')

  return _.pickBy({ facets, rangeFacets, categoryFilter, vehicleFilter })
}

export function applyFilterQueryParams() {
  const parameters = getUrlFilterQueryParams()
  if(parameters.facets) {
    const parsedFacets = parameters.facets
    if(_.isObject(parsedFacets)) {
      _.forEach(parsedFacets, (val, key) => {
        if(state.selectableFacets[key]) {
          state.selectableFacets[key].distinctValues = val
        }
      })
    }
  }
  if(parameters.rangeFacets) {
    const parsedFacets = parameters.rangeFacets
    if(_.isObject(parsedFacets)) {
      _.forEach(parsedFacets, (val, key) => {
        if(state.selectableFacets[key]) {
          state.selectableFacets[key].userSelection = [val.min, val.max]
        }
      })
    }
  }
  if(parameters.categoryFilter) {
    state.selectedCategory = parameters.categoryFilter
  } else {
    state.selectedCategory = DEFAULT_CATEGORY_NODE
  }
  if(parameters.vehicleFilter) {
    state.selectedVehicle = parameters.vehicleFilter
  }

  state.hasAppliedFilterQueryParams = true
}

export function clearFilters() {
  sessionStorage.removeItem('lastFacetUsed')
  state.selectedCategory = DEFAULT_CATEGORY_NODE
  Bus.publish('close-all-nodes')
  state.selectedVehicle = ''

  const selectedFacetsValue = selectedFacets()
  if(selectedFacetsValue) {
    _.forEach(selectedFacetsValue, (val, key) => {
      state.selectableFacets[key].distinctValues = []
    })
  }

  const selectedRangeFacetsValue = selectedRangeFacets()
  if(selectedRangeFacetsValue) {
    _.forEach(selectedRangeFacetsValue, (val, key) => {
      const originalMin = state.selectableFacets[key].originalMinMax[0]
      const originalMax = state.selectableFacets[key].originalMinMax[1]
      state.selectableFacets[key].currentMinMax = [originalMin, originalMax]
      state.selectableFacets[key].distinctValues = []
      state.selectableFacets[key].userSelection = []
    })
  }

  Bus.publish('filters-cleared')
}

export function getCachedInitialFilters(key) {
  const cachedFilters = JSON.parse(sessionStorage.getItem('initialFilters'))
  if(cachedFilters) {
    if(cachedFilters.key === key) {
      return cachedFilters.data
    }
  }
}
export function getCachedLatestFilters(key, filterParameters) {
  const cachedFilters = JSON.parse(sessionStorage.getItem('latestFilters'))
  if(cachedFilters) {
    if(_.isEqual(cachedFilters.filters, filterParameters) && cachedFilters.key === key) {
      return cachedFilters.data
    }
  }
}

export function checkLastFacetUsed() {
  const lastFacetUsed = JSON.parse(sessionStorage.getItem('lastFacetUsed'))
  if(lastFacetUsed && lastFacetUsed.type === 'category') return
  sessionStorage.removeItem('lastFacetUsed')
}
